import { getCookie } from '../utils';
import axios from '../axios';
import ApiRequests from "./ApiRequests";
export default {
  getUser() {
    return  ApiRequests.apiRequest('get','portal/user',{params : {
      user_id:`${getCookie('user_id')}`,
        
    }},null).then(data =>{return data})

  },
  getCompanyInfo(){
    return axios()
      .get(`portal/portalSettings`, {})
      .then((res) => {
        if (res.data.STATUS == true) return res.data.Data;
        else throw Error('Server Error, Code: ' + res.data.CODE);
      });

  }
};
